import { ClubZapierConfigDTO, ClubZapierStatusDTO } from "@gymflow/types";
import { AxiosInstance } from "axios";

export type ZapierApiType = ReturnType<typeof zapierApi>;
const zapierApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    getIntegrationStatus() {
      return axiosInstance.get<ClubZapierStatusDTO>(
        `${clubPrefix}zapier-config/status`,
      );
    },
    getIntegrationConfig() {
      return axiosInstance.get<ClubZapierConfigDTO>(
        `${clubPrefix}zapier-config`,
      );
    },
    enableIntegration() {
      return axiosInstance.post(`${clubPrefix}zapier-config/status`);
    },
    disableIntegration() {
      return axiosInstance.delete(`${clubPrefix}zapier-config/status`);
    },
  };
};

export default zapierApi;
